import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { OrderAdjustmentsFormValues } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentsForm';
import { ErrorData } from 'types/embedded/error';

export type CreateOrderAdjustmentResponse = {
  count: number;
  requestId: string;
};

export const createOrderAdjustments = async (
  data: OrderAdjustmentsFormValues,
): Promise<CreateOrderAdjustmentResponse> => {
  return axios
    .post('order_adjustment/bulk/create', data)
    .then((response: AxiosResponse<CreateOrderAdjustmentResponse>) => response.data)
    .catch((error: AxiosError<{ data: ErrorData }>) => Promise.reject(error.response?.data));
};
